import React from 'react';
import { NavLink } from "react-router-dom";
import DataTable from 'react-data-table-component';
import { Alert }  from 'reactstrap';
import { TableSearchForm } from '../Common/TableSearchForm';
import { ClassificationTypeActionsButton } from './ActionsButton';

export const ClassificationTypesList = (props) => {
    const columns = [
        {
            name: 'Name',
            selector: 'name',
            sortable: true,
            ignoreRowClick: true,
            cell: (row) => {
                return <NavLink to={'/classification-types/edit/' + row.id}>{row.name}</NavLink>
            }
        },
        {
            name: 'Days Estimated for Completion',
            selector: 'daysEstimated',
            sortable: true
        },
        {
            name: '',
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            cell: (row) => {
                return (
                    <ClassificationTypeActionsButton 
                        classificationType={row} 
                        handleEdit={props.handleEdit} 
                        handleDelete={props.handleDelete}
                    />
                );
            }
        }
    ];

    const hasAny = props.items && props.items.length > 0;

    return (
        <>
            <TableSearchForm handleSearch={props.handleSearch} />
            {
                hasAny ? (
                    <DataTable
                        columns={columns}
                        data={props.items}
                        defaultSortField="name"
                        pagination
                        highlightOnHover
                        noHeader
                        paginationPerPage={50}
                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    />
                ) : <Alert color="warning">No Classification Types were found</Alert>
            }
        </>
    );
}

